// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD
import { css } from 'lit-element';
/**
 * exports lit-element css
 * @export styles
 */
export const styles = [
    css `
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
/*
  Your use of the content in the files referenced here is subject to the terms of the license at http://aka.ms/fabric-assets-license
*/
/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
:host([hidden]) {
  display: none; }

:host {
  display: block;
  --default-font-family: 'Segoe UI', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont,
    Roboto, 'Helvetica Neue', sans-serif;
  --theme-primary-color: #0078d7;
  --theme-dark-color: #005a9e; }

.ms-Icon {
  display: inline-block;
  font-family: 'FabricMDL2Icons';
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  margin: 4px 0; }

.ms-Icon--ChevronDown::before {
  content: '\\\E70D'; }

.ms-Icon--ChevronUp::before {
  content: '\\\E70E'; }

.ms-Icon--Contact::before {
  content: '\\\E77B'; }

.ms-Icon--AddFriend::before {
  content: '\\\E8FA'; }

.ms-Icon--OutlookLogoInverse::before {
  content: '\\\EB6D'; }

:host .header,
mgt-agenda .header {
  margin: var(--agenda-header-margin, 40px 10px 14px 10px);
  font-family: var(--default-font-family);
  font-size: var(--agenda-header-font-size, 24px);
  color: var(--agenda-header-color, #333333); }

:host .agenda > .group:first-child > .header,
mgt-agenda .agenda > .group:first-child > .header {
  margin-top: 0; }

:host .agenda-list,
mgt-agenda .agenda-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-family: var(--default-font-family);
  font-style: normal;
  font-weight: normal; }

:host .event,
mgt-agenda .event {
  background: var(--event-background, #ffffff);
  border: var(--event-border, solid 2px rgba(0, 0, 0, 0));
  box-shadow: var(--event-box-shadow, 0px 2px 8px rgba(0, 0, 0, 0.092));
  margin: var(--event-margin, 0px 10px 14px 10px);
  padding: var(--event-padding, 0px);
  display: flex; }

:host .narrow .event,
mgt-agenda .narrow .event {
  flex-direction: column; }

:host .event-time-container,
mgt-agenda .event-time-container {
  display: flex;
  flex-direction: column;
  margin: 18px 38px 18px 18px;
  width: 120px; }

:host .narrow .event-time-container,
mgt-agenda .narrow .event-time-container {
  margin: 14px 18px 8px 18px; }

:host .event-time,
mgt-agenda .event-time {
  font-size: var(--event-time-font-size, 12px);
  color: var(--event-time-color, #000000);
  font-weight: 600; }

:host .event-duration,
mgt-agenda .event-duration {
  color: rgba(16, 16, 16, 0.3); }

:host .event-details-container,
mgt-agenda .event-details-container {
  margin: 14px 18px 14px 0px; }

:host .narrow .event-details-container,
mgt-agenda .narrow .event-details-container {
  margin: 0px 18px 14px 18px; }

:host .event-subject,
mgt-agenda .event-subject {
  margin: 0px 18px 0px 0px;
  font-size: var(--event-subject-font-size, 19px);
  color: var(--event-subject-color, #333333); }

:host .event-location-container,
mgt-agenda .event-location-container {
  display: flex;
  margin: 8px 18px 0px 0px; }

:host .event-location,
mgt-agenda .event-location {
  font-size: var(--event-location-font-size, 12px);
  color: var(--event-location-color, #000000);
  margin: 0px 0px 0px 4px; }

:host .event-attendees,
mgt-agenda .event-attendees {
  --list-margin: 8px 0 0 0;
  --avatar-size-s: 20px; }

:host .event-other-container,
mgt-agenda .event-other-container {
  margin: 2px 16px 4px 16px;
  margin-left: auto; }

:host .loading-element,
mgt-agenda .loading-element {
  background: #f2f2f2;
  border-radius: 1px; }

:host .event-time-loading,
mgt-agenda .event-time-loading {
  width: 100px;
  height: 10px; }

:host .event-subject-loading,
mgt-agenda .event-subject-loading {
  width: 263px;
  height: 16px; }

:host .event-location-icon-loading,
mgt-agenda .event-location-icon-loading {
  width: 14px;
  height: 14px; }

:host .event-location-loading,
mgt-agenda .event-location-loading {
  width: 90px;
  height: 10px;
  margin: 2px 0px 0px 4px; }

:host .event-attendee-loading,
mgt-agenda .event-attendee-loading {
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin: 0 2px 0 0; }

`
];
//# sourceMappingURL=mgt-agenda-css.js.map